export default __webpack_public_path__ + "overview-1200-04e581501ef81b9c1f159eb198944304.png";